import { ToolComponents, ToolPart } from "@zapier/ai-toolkit";
import {
  CopilotMessageList,
  GetToolCallDisplay,
  RenderPart,
} from "@zapier/design-system-ai";
import { UIMessage } from "ai";
import { useCallback } from "react";
import {
  PlanRequirementsComponent,
  planRequirementsTool,
} from "src/lib/copilot/tools/planRequirements";

type CopilotMessagesProps = {
  messages: UIMessage[];
};

export const CopilotMessages = ({ messages }: CopilotMessagesProps) => {
  const componentToolSpecs = [planRequirementsTool];
  const Components: ToolComponents<typeof componentToolSpecs> = {
    planRequirements: PlanRequirementsComponent,
  };

  const renderPart: RenderPart = useCallback((_, part) => {
    if (
      part.type === "tool-invocation" &&
      part.toolInvocation.state === "result"
    ) {
      return <ToolPart part={part} Components={Components} />;
    }

    return undefined;
  }, []);

  const getToolCallDisplay: GetToolCallDisplay = useCallback((_, part) => {
    if (part.type === "tool-invocation") {
      switch (part.toolInvocation.toolName) {
        case "planRequirements":
          return {
            icon: undefined,
            message: "Checking plan requirements...",
          };
      }
    }

    return undefined;
  }, []);

  return (
    <CopilotMessageList
      messages={messages}
      renderPart={renderPart}
      getToolCallDisplay={getToolCallDisplay}
    />
  );
};
